import { Enums } from "constants/AppConstants";

const EnumToUI = (enumKey = "", location = "") => {
  return Enums?.[location]?.[enumKey] || "";
};

export default EnumToUI;
